import {useMutation, useQueryClient} from "@tanstack/react-query";
import {fileApi} from "../services/fileService";

export const useAddFile = () => {
  const queryClient = useQueryClient();
  const onAdd = async (values, onUploadProgress) => {
    const response = await fileApi.add(values, onUploadProgress);
    await queryClient.invalidateQueries({queryKey: ["getMe"]});
    return response;
  };
  return {onAdd};
};

export const useDeleteFile = () => {
  const queryClient = useQueryClient();
  const {mutateAsync: mutate} = useMutation({
    mutationFn: fileApi.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["getMe"]});
    },
  });
  const onDelete = ({id}) => {
    return mutate({id});
  };
  return {onDelete};
};
